import { render, staticRenderFns } from "./StatusIconBase.vue?vue&type=template&id=3321496a&"
import script from "./StatusIconBase.vue?vue&type=script&lang=ts&"
export * from "./StatusIconBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports